// extracted by mini-css-extract-plugin
var _1 = "ChartDonut-modulecontainer__oRjL6";
var _2 = "ChartDonut-modulelegend__RbBRj ChartLegend-modulelegend__Qoxj9";
var _3 = "ChartDonut-modulepie__mn7UI";
var _4 = "ChartDonut-moduletooltip__SjFzg ChartTooltip-moduletooltip__Eft3_";
var _5 = "ChartDonut-modulewrap__f4gIF";
export { _1 as "container", _2 as "legend", _3 as "pie", _4 as "tooltip", _5 as "wrap" }
